import {Box, SelectChangeEvent} from '@mui/material';
import dayjs from 'dayjs';
import {FC, useState} from 'react';
import {Range} from 'react-date-range';
import {useIntl} from 'react-intl';
import {timeMap} from 'src/components/forms/formData/common/initialData';
import {PickCustomPeriodForm} from 'src/components/forms/PickCustomPeriodForm';
import {PickCustomPeriodFormReturnType} from 'src/components/forms/PickCustomPeriodForm/PickCustomPeriodForm.types';
import AMPModal from '../AMPModal';
import {TimeSelect} from '../TimeSelect';
import {DateSelectType} from './DateSelect.types';

export const DateSelect: FC<DateSelectType> = ({
                                                   field,
                                                   handleSaveCurrentTimeIndex,
                                                   currentTimeInit = 3,
                                                   handleTimeChange,
                                                   contractLimit,
                                                   handleShowOverlimit,
                                                   handleHideOverlimit,
                                                   dateFrom,
                                                   disabled,
                                                   dense,
                                               }) => {
    const intl = useIntl();

    const [currentTime, setCurrentTime] = useState(currentTimeInit);
    const [showCalendar, setShowCalendar] = useState(false);

    const handleShowCalendar = () => {
        setShowCalendar(true);
    };
    const handleHideCalendar = () => {
        setShowCalendar(false);
    };

    const dateRange: Range = {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    };

    const handleCustomClick = () => {
        handleShowCalendar();
    };

    const onSelect = (e: SelectChangeEvent) => {
        const value = Number(e.target.value);
        setCurrentTime(value);
        handleSaveCurrentTimeIndex && handleSaveCurrentTimeIndex(value);
        if (value !== 5 && field) {
            const dateFromContract =
                value === 6 ? dateFrom : timeMap(intl, handleCustomClick)[value]?.dateFrom;
            handleTimeChange && handleTimeChange(dateFromContract ?? 0, dayjs.utc().valueOf(), field)();
        }
        if (value === 6 && handleShowOverlimit) {
            handleShowOverlimit();
            return;
        }
        handleHideOverlimit && handleHideOverlimit();
    };

    const onSubmitRange = () => {
        return (values: PickCustomPeriodFormReturnType) => {
            // Extract date parts from local Date and create UTC dates
            const startLocal = dayjs(values.range.startDate);
            const endLocal = dayjs(values.range.endDate);

            const startDate = dayjs.utc()
                .year(startLocal.year())
                .month(startLocal.month())
                .date(startLocal.date())
                .hour(0)
                .minute(0)
                .second(0);

            const endDate = dayjs.utc()
                .year(endLocal.year())
                .month(endLocal.month())
                .date(endLocal.date())
                .hour(23)
                .minute(59)
                .second(59);

            handleTimeChange &&
            field &&
            handleTimeChange(startDate.valueOf(), endDate.valueOf(), field)();
            handleHideCalendar();
        };
    };
    return (
        <>
            <Box
                sx={{
                    // The third layer of the same compensation: AMPFormSelect's `margin="normal"`
                    // already leaves 8px below, and this adds 8px more. In a toolbar both are dead
                    // space the row centres around, which is what made the period select read as
                    // sitting higher than the controls beside it.
                    marginBottom: dense ? 0 : '8px',
                }}
            >
                <TimeSelect
                    currentTime={currentTime}
                    onChange={onSelect}
                    onSubmitRange={onSubmitRange}
                    showCalendar={showCalendar}
                    handleCustomClick={handleCustomClick}
                    handleShowCalendar={handleShowCalendar}
                    handleHideCalendar={handleHideCalendar}
                    handleShowOverlimit={handleShowOverlimit}
                    contractLimit={contractLimit}
                    disabled={disabled}
                    dense={dense}
                />
            </Box>
            <AMPModal
                handleClose={handleHideCalendar}
                open={showCalendar}
                title={intl.formatMessage({id: 'customPeriod'})}
                type="md"
                fullWidth
                withoutPaddings
            >
                <PickCustomPeriodForm
                    handleClose={handleHideCalendar}
                    handleSubmit={onSubmitRange()}
                    initialValues={{
                        range: dateRange,
                    }}
                />
            </AMPModal>
        </>
    );
};
